import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../utils/styles.css";
import API_URL from "../../utils";
import { FiRefreshCw } from "react-icons/fi";

const AccuzipQueue = ({ isDarkMode }) => {
  const [accuzipQueue, setAccuzipQueue] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [refreshInterval, setRefreshInterval] = useState(
    localStorage.getItem("accuzipRefreshInterval") || "120"
  );
  useEffect(() => {
    fetchQueueData();
  }, []);

  const fetchQueueData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/queue/queue-files`);
      const files = response.data.files || response.data || [];
      setAccuzipQueue(files);
      setError("");
    } catch (err) {
      setError("Failed to fetch data");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleRefresh = () => {
    fetchQueueData();
  };
  console.log(refreshInterval, "refreshInterval");

  const intervalOptions = [
    { value: "30", label: "30 seconds" },
    { value: "60", label: "1 minute" },
    { value: "120", label: "2 minutes" },
    { value: "300", label: "5 minutes" },
    { value: "600", label: "10 minutes" },
  ];

  useEffect(() => {
    fetchQueueData();
    const intervalId = setInterval(fetchQueueData, refreshInterval * 1000);
    return () => clearInterval(intervalId);
  }, [refreshInterval]);

  const handleIntervalChange = (e) => {
    const value = e.target.value;
    setRefreshInterval(value);
    localStorage.setItem("accuzipRefreshInterval", value);
  };

  // Format order ID with #
  const formatOrderId = (id) => {
    return `#${id}`;
  };

  return (
    <div className={`accuzip-container`} id={isDarkMode ? "dark-mode" : ""}>
      <div className="accuzip-header">
        <div className="header-left">
          <div className="server-info"></div>
        </div>

        <div className="header-actions">
          <div className="interval-selector">
            <label htmlFor="refreshInterval">Queue Refresh:</label>
            <select
              id="refreshInterval"
              value={refreshInterval}
              onChange={handleIntervalChange}
              className="interval-dropdown"
            >
              {intervalOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
          <div className="stats">
            {accuzipQueue.length > 0 && (
              <span className="order-count">
                <strong>{accuzipQueue.length}</strong>
                {accuzipQueue.length > 1 ? " Order" : " Orders"}
              </span>
            )}
          </div>
          <button
            onClick={handleRefresh}
            disabled={loading}
            className="refresh-btn"
          >
            {loading ? (
              <>
                <span className="spinner"></span> Loading...
              </>
            ) : (
              <>
                <FiRefreshCw />
                Refresh
              </>
            )}
          </button>
        </div>
      </div>

      {loading ? (
        <div className="loading">
          <div className="spinner"></div>
          <p>Loading queue data...</p>
        </div>
      ) : accuzipQueue.length === 0 ? (
        <div className="no-orders">
          <div className="empty-state">
            <span className="empty-icon">📂</span>
            <h3>No orders in queue</h3>
            <p>The queue is currently empty</p>
          </div>
        </div>
      ) : (
        <>
          <div className="table-container">
            <table className="orders-table">
              <thead>
                <tr>
                  <th width="20%">Order ID</th>
                  <th width="25%">Name</th>
                  <th width="20%">List Number</th>
                  <th width="20%">Server</th>
                </tr>
              </thead>
              <tbody>
                {accuzipQueue.map((order, index) => (
                  <tr
                    key={index}
                    className={index % 2 === 0 ? "even-row" : "odd-row"}
                  >
                    <td>
                      <div className="order-id-cell">
                        {formatOrderId(order.orderId)}
                      </div>
                    </td>
                    <td>{order.name}</td>
                    <td>
                      <span className="list-badge">{order.listNumber}</span>
                    </td>
                    <td>
                      <span className="list-badge">
                        {order.serverNumber.replace(/\D/g, "") || "1"}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default AccuzipQueue;
